export const STEPS = [
  {
    data: {},
    stepIndex: 1,
    isComplete: false,
    name: 'Datos personales',
  },
  {
    data: {},
    stepIndex: 2,
    isComplete: false,
    name: 'Motivo de visita',
  },
  {
    data: {},
    stepIndex: 3,
    isComplete: false,
    name: 'Selección de sucursal',
  },
  {
    data: {},
    stepIndex: 4,
    isComplete: false,
    name: 'Selección de fecha',
  },
  { data: {}, stepIndex: 5, isComplete: true, name: 'Confirmación' },
];

export const MANAGE_STEPS = [
  {
    data: {},
    isComplete: false,
    stepIndex: 1,
    name: 'Datos personales',
  },
  {
    data: {},
    isComplete: false,
    stepIndex: 2,
    name: 'Código de autenticación',
  },
  {
    data: {},
    isComplete: false,
    stepIndex: 3,
    name: 'Anulación',
  },
];

export const stepperServiceMock = {
  stepsDataStore: {
    1: {
      data: {
        region: 'Metropolitana de Santiago',
        commune: 'Santiago',
        office: '1',
        name: 'John Doe',
        rut: '123456789',
        email: 'johndoe@example.com',
        phone: '+1234567890',
      },
    },
    2: {
      data: {
        region: 'Metropolitana de Santiago',
        commune: 'Santiago',
        office: '14',
        day: '2023-10-18T03:00:00.000Z',
        hour: '13:00',
        reason: {
          idSerie: '16',
          serie: 'Caja Agenda Personas',
          tipoSerAge: '0',
        },
      },
    },
    3: {
      data: {},
    },
  },
  currentStep: {
    stepIndex: 1,
  },

  getCurrentStep() {
    return STEPS[stepperServiceMock.currentStep.stepIndex];
  },

  setCurrentStep(step: any) {
    stepperServiceMock.currentStep.stepIndex = step.stepIndex;
  },
} as any;
